export default __webpack_public_path__ + "static/media/StockPorUbicacion.82eb4826.png";